import loadable from '@loadable/component';

const AuthPage = loadable(() => import('./AuthPage/AuthPage'));
const Layout = loadable(() => import('../main/Layout'));

export {
	AuthPage,
	Layout
};
